import styled from '@emotion/styled';
import {
  type AllowedColors,
  colors as proximaColors,
  Text,
  type TextVariantType
} from '@innovationdepartment/proxima-ui';
import type React from 'react';

type TagProps = {
  colors?: {
    bgColor?: (typeof proximaColors)[keyof typeof proximaColors];
    textColor?: (typeof proximaColors)[keyof typeof proximaColors];
  };
  label: string | React.ReactNode;
  disabled?: boolean;
  variant?: TextVariantType;
};

const TagWrapper = styled.div<Partial<TagProps>>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 14px;

  ${({ disabled, colors }) => {
    if (colors?.bgColor) {
      return `background-color: ${colors.bgColor};`;
    }

    return `background-color: ${disabled ? proximaColors.neutral5 : proximaColors.neutral10};`;
  }}
`;

// TODO(Jenky): Might move this to UI library
const Tag = ({ label, disabled = false, variant = 'tag2Medium', colors = {} }: TagProps) => {
  const textColor =
    colors?.textColor || (disabled ? proximaColors.neutral30 : proximaColors.neutral80);
  return (
    <TagWrapper disabled={disabled} colors={colors}>
      {typeof label === 'string' ? (
        <Text variant={variant} color={textColor as AllowedColors}>
          {label}
        </Text>
      ) : (
        label
      )}
    </TagWrapper>
  );
};

export default Tag;
